import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { gsApi } from "../auth/auth";
import { fileUplaod, thunkResponse } from "../app/api";

export const uploadFile = createAsyncThunk(
  "utilities/uploadFile",
  async (file, thunkAPI) => {
    const response = await gsApi.post(`${fileUplaod}`, file);
    return response;
  }
);

export const utilitySlice = createSlice({
  name: "utilities",
  initialState: {
    uploadedFile: "",
    croppedImage: {},
    croppedTarget: {},
    utilityNotifications: [],
    loading: [],
  },
  reducers: {
    setUploadedFile: (state, action) => {
      state.uploadedFile = action.payload;
    },
    setCroppedImage: (state, action) => {
      state.croppedImage = action.payload;
    },
    setCroppedTarget: (state, action) => {
      state.croppedTarget = action.payload;
    },
    notifySlideOut: (state, action) => {
      state.utilityNotifications.push(action.payload);
    },
    clearUtilityNotifications: (state, action) => {
      state.utilityNotifications = [];
    },
  },
  extraReducers: {
    ...thunkResponse(
      uploadFile,
      (state, action) => {
        state.uploadedFile = action.payload.data.location;
      },
      "File Upload",
      {
        pendingText: "Uploading File",
        pendingDelay: 0,
        fulfilledText: "File has been uploaded!",
        fulfilledDelay: 0,
        rejectedDelay: 0,
      }
    ),
  },
});

export const {
  setUploadedFile,
  setCroppedImage,
  setCroppedTarget,
  notifySlideOut,
  clearUtilityNotifications,
} = utilitySlice.actions;

export const selectCroppedTarget = (state) => state.utilities.croppedTarget;

export const selectUploadedFile = (state) => state.utilities.uploadedFile;

export const selectCroppedImage = (state) => state.utilities.croppedImage;

export const selectUtilityNotifications = (state) => state.utilities.utilityNotifications;

export default utilitySlice.reducer;
